import { Typography } from "antd"
import { ColumnsType } from "antd/es/table"

import { NoContent } from "@src/app/components/NoContent/Index"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { Transaction } from "@src/app/transactionsStore"
import { dateTimeFormat } from "@src/shared/date"

export const statusOptions = [
  { label: "Pending", value: "pending" },
  { label: "Posted", value: "posted" },
]
export const typeOptions = [
  { label: "Charge", value: "charge" },
  { label: "Checkout", value: "checkout" },
  { label: "Deposit", value: "deposit" },
  { label: "Convert", value: "convert" },
  { label: "Invoice", value: "invoice" },
  { label: "Payout", value: "payout" },
  { label: "Refund", value: "refund" },
  { label: "Top Up", value: "topup" },
  { label: "Withdrawal", value: "withdrawal" },
]
export const noContent = (
  <NoContent
    paragraph="Wait for your first transaction to start receiving reports."
    title="No Transactions Yet"
  />
)
